import { FormProvider } from 'react-hook-form';
import { useEditTopBannerForm } from './hooks';
import { convertToPresentationProps } from './logics';
import { EditTopBannerFormPresentation } from './presentations';

type Props = {
  /** 編集対象のトップバナーID */
  topBannerId: number;
};

/**
 * トップバナー編集フォームのコンテナコンポーネント
 * NOTE: Suspenseを使用するhookを含むため、親コンポーネントでSuspenseでラップしてください
 */
export const EditTopBannerForm: React.FC<Props> = ({ topBannerId }) => {
  const {
    state: { methods, data, groupsData, isImageRemovedRef, isMutating },
    actions: { handleOnSubmit, handleImageRemove },
  } = useEditTopBannerForm(topBannerId);

  const { bannerTitle, groupList, existingImageUrl, isButtonDisabled } = convertToPresentationProps(
    {
      data,
      groupsData,
      isImageRemoved: isImageRemovedRef.current,
      isMutating,
      isFormValid: methods.formState.isValid,
    }
  );

  return (
    <FormProvider {...methods}>
      <EditTopBannerFormPresentation
        bannerTitle={bannerTitle}
        groupList={groupList}
        isButtonDisabled={isButtonDisabled}
        existingImageUrl={existingImageUrl}
        onSubmit={handleOnSubmit}
        onImageRemove={handleImageRemove}
      />
    </FormProvider>
  );
};
